// BFSG
import * as React from 'react'
import styled from 'styled-components'
import { useDisplayVariant } from 'modules/productDetail'
import { GalleryProvider } from './hooks/useGalleryContext'
import GalleryLightbox from './GalleryLightbox'
import ImageGallery from './ImageGallery'

type Props = {
  path: string
}
/**
 *
 * @param props
 * @returns
 * actions:
 * - track change image event on mobile
 * - set index to 0 when sku changes
 * - set height of video wrapper
 *
 */
export default function Gallery(props: Props) {
  const [showGalleryLightbox, setShowGalleryLightbox] = React.useState(false)
  const variant = useDisplayVariant()

  return (
    <GalleryProvider images={variant.data.images}>
      <Wrapper className="Gallery" data-cy-collection="Gallery">
        <ImageGallery
          path={props.path}
          openLightbox={() => setShowGalleryLightbox(true)}
          showGalleryLightbox={showGalleryLightbox}
        />
        {showGalleryLightbox && (
          <GalleryLightbox
            data-cy-state="show-gallery-lightbox"
            onClose={() => setShowGalleryLightbox(false)}
            visible={showGalleryLightbox}
          />
        )}
      </Wrapper>
    </GalleryProvider>
  )
}

const Wrapper = styled.div``
